// Load all the controllers within this directory (non-recursive; subdirectories load separately below).
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()
const context = require.context("controllers", false, /_controller\.js$/)
Stimulus.load(definitionsFromContext(context))

// SNP controllers (controllers/snp/): loaded with snp- prefix so identifiers read snp-form,
// snp-calculator etc. — matching the snp/ views namespace and avoiding Stimulus's snp-- double-dash.
const snpContext = require.context("controllers/snp", true, /_controller\.js$/)
const snpDefs = definitionsFromContext(snpContext)
Stimulus.load(snpDefs.map((def) => ({ ...def, identifier: 'snp-' + def.identifier })))

// Component controllers: load with a prefix to avoid conflicts with controllers in this directory
// app/components/ui/example/example_controller.js turns into component-example
const componentControllersContext = require.context("../../components/ui", true, /_controller\.js$/)
const componentDefs = definitionsFromContext(componentControllersContext)
const defsWithShortId = componentDefs.map((def) => ({
  ...def,
  identifier: "component-" + def.identifier.split("--").pop()
}))
Stimulus.load(defsWithShortId)